import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicButton from '../../Components/Button_Basic';
import Dialog from '../../Services/Common/Dialog';
import DatePicker from '../../Components/Datepicker_Basic';
import FormGroup from '../../Components/Form_Group';
import CardH3 from '../../Components/Card_H3';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Commons from '../../Services/Common/Common';

function PM10020(props) {
    React.useEffect(() => {
        document.title = '발주현황조회';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '구매관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>발주현황조회</strong>" +
            '</h1>';
    }, []);
    const gridRef = React.useRef();

    //상단 그리드 컬럼
    const columnDefs = [
        {
            field: 'poCreatDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '', //생성일자
        },
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '', //거래처명
            minWidth: 200,
        },

        {
            field: 'delivDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DliveDate' && f.lanType === 'COL')[0].lanName
                    : '', //납기일자
        },
        {
            field: 'poStusCode',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoSatusNm' && f.lanType === 'COL')[0].lanName
                    : '', //진행상태
            cellStyle: { textAlign: 'center' },
            cellRenderer: Commons.CustomHeaderRenderer,
        },

        {
            field: 'arriveCustCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ArrivCustCd' && f.lanType === 'COL')[0].lanName
                    : '', //납품장소
        },
        {
            field: 'poTypeNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoTypeName' && f.lanType === 'COL')[0].lanName
                    : '', //거래유형
        },
        {
            field: 'currencyCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CurrencyNm' && f.lanType === 'COL')[0].lanName
                    : '', //거래통화
        },
        {
            field: 'poDelivReqDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoDeliveRequestDate' && f.lanType === 'COL')[0]
                          .lanName
                    : '', //납품요청일
        },
        {
            field: 'reference',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Reference' && f.lanType === 'COL')[0].lanName
                    : '', //참조
        },
        // {
        //   field: "filePath",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_FileNm" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //파일명
        // },
        {
            field: 'poNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoNo' && f.lanType === 'COL')[0].lanName
                    : '', //발주번호
        },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
            cellStyle: { textAlign: 'center' },
        },
    ];
    const gridRef1 = React.useRef();
    //하단 그리드 컬럼
    const columnDefs1 = [
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_InWhCd' && f.lanType === 'COL')[0].lanName
                    : '', //입고창고
            minWidth: 140,
            cellRenderer: Commons.CustomWhCdRenderer,
        },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목명
            minWidth: 300,
        },

        {
            field: 'itemStd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd1' && f.lanType === 'COL')[0].lanName
                    : '', //규격
            cellStyle: { textAlign: 'center' },
            minWidth: 110,
        },
        {
            field: 'poAddItemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemQty' && f.lanType === 'COL')[0].lanName
                    : '', // 발주수량
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            minWidth: 110,
        },
        {
            field: 'poItemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemBomQty' && f.lanType === 'COL')[0].lanName
                    : '', // 수량(BOM)
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            minWidth: 110,
        },
        {
            field: 'itemUnit',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '', // 단위
        },
        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStdAmt' && f.lanType === 'COL')[0].lanName
                    : '', // 단가
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            // aggFunc: "sum",
        },
        {
            field: 'poItemAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemAmt' && f.lanType === 'COL')[0].lanName
                    : '', // 공급가액
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
        },
        {
            field: 'poItemVat',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemVat' && f.lanType === 'COL')[0].lanName
                    : '', // 부가세
            valueFormatter: (params) => {
                var formatted = params.value
                    ? parseFloat(params.value)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
        },
        {
            field: 'poRemarkDtl',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_RemarkDtl' && f.lanType === 'COL')[0].lanName
                    : '', // 적요
        },
        {
            field: 'poItemCost',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemCost' && f.lanType === 'COL')[0].lanName
                    : '0', // 단가(VAT포함)
            cellStyle: { textAlign: 'right' },
            // aggFunc: "sum",
            minWidth: 150,
        },
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //품목코드
            cellRenderer: (e) => {
                return !e.data ? 'TOTAL' : e.data.itemCd;
            },
            minWidth: 110,
        },
    ];

    const onCellClicked = (e) => {
        const selected = e.data;
        props.GetPurchaseOrderDtls(selected.poNo);
    };

    return (
        <div>
            <div>
                <div style={{ height: '50%' }}>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <DatePicker
                                className={'datepicker-custom-input'}
                                style={{ width: '120px', marginRight: '5px' }}
                                selected={props.startDate}
                                onChange={(e) => {
                                    props.setStartDate(e);
                                }}
                            />
                            ~
                            <DatePicker
                                className={'datepicker-custom-input'}
                                style={{ width: '120px', marginLeft: '5px' }}
                                selected={props.endDate}
                                onChange={(e) => {
                                    props.setEndDate(e);
                                }}
                            />
                        </div>
                        {/* 상단 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="PM10020"
                            target="G01"
                            refreshNone="none"
                            // refreshFunc={() => {
                            //   props.Init();
                            // }}
                            selectFunc={() => {
                                props.SearchLogic();
                            }}
                            addFunc={() =>
                                // gridRef.current.api.setRowData([{}, ...props.rowData])
                                props.setModalToggle(true)
                            }
                            saveFunc={() => props.SaveConfirm()}
                            deleteFunc={() => props.DeleteConfirm()}
                            onCellClicked={onCellClicked}
                        />
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '335px' }}>
                        {/* 상단 그리드 */}
                        <AgGridReact
                            ref={gridRef}
                            animateRows={true}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 80,
                                editable: false,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            onCellValueChanged={(e) =>
                                GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                            }
                            rowData={props.rowData}
                            rowSelection="single"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)
                            }
                            onCellClicked={onCellClicked}
                        />
                    </div>
                </div>

                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '440px' }}>
                    {/* 하단 그리드  */}
                    <AgGridReact
                        ref={gridRef1}
                        animateRows={true}
                        columnDefs={columnDefs1}
                        groupIncludeTotalFooter={true}
                        defaultColDef={{
                            flex: 1,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        onCellValueChanged={(e) =>
                            GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                        }
                        rowSelection="single"
                        rowData={props.rowData1}
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef1, props.setSelectedRowData1)}
                    />
                </div>
            </div>
        </div>
    );
}

export default PM10020;
